import * as React from "react";
import "./container.css";
import { useEffect } from "react";
import executeRequest from "../../../../modules/request.js";
import { parse } from "query-string";
import { useState } from "react";
import LoadingComponent from "../../../../shared/ui/animations/loading.js";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import { toast } from "react-toastify";
import ContainerWithDownloadables from "../containerWithDownloadables/containerWithDownloadables.js";
import { useUpdateEffect } from "../../../../../../merchant/panel/hooks/useUpdateEffect.js";
import { updateStyle } from "../../../client/gallery/scripts/useStyle.js";
import LinkToCollection from "../LinkToCollection/LinkToCollection.js";
import OrderedImagesList from "../../../../../../merchant/panel/components/orderedImagesList/orderedImagesList.js";
import { post } from "../../../../modules/post.js";
export default function Container(props) {
    const { key, orderId } = parse(location.search);
    const [orderData, setOrderData] = useState(undefined);
    useEffect(() => {
        let timeout;
        const update = () => {
            executeRequest(`/api/public/users/order/${orderId}?key=${key}`, "GET", {}).then((res) => {
                if (res.status == 200) {
                    if (res.paymentState !== "payed")
                        setTimeout(update, 2500);
                    setOrderData(res);
                }
            });
        };
        update();
        return () => {
            clearTimeout(timeout);
        };
    }, []);
    useUpdateEffect(() => {
        if (!(orderData === null || orderData === void 0 ? void 0 : orderData.style))
            return;
        updateStyle(orderData.style, orderData.design);
    }, [orderData]);
    useEffect(() => {
        if (!orderId || !key)
            return;
        post("/api/public/users/events/add", {
            event: {
                event: "order_summary_visit",
                orderId: String(orderId),
            },
        }).then(() => { });
    }, []);
    if (!orderId || !key)
        return React.createElement("div", null, "Nieprawid\u0142owe \u017C\u0105danie");
    return (React.createElement("div", { className: "order-container" }, !orderData ?
        React.createElement(LoadingComponent, { color: "classic" })
        : orderData.hasDownloadableFiles === true ?
            React.createElement(ContainerWithDownloadables, { orderId: orderId, order: orderData, orderKey: key })
            : React.createElement(React.Fragment, null,
                "Id zam\u00F3wienia: ",
                orderId,
                React.createElement("br", null),
                "Na imi\u0119 i nazwisko: ",
                orderData.name,
                React.createElement("br", null),
                "Kwota: ",
                orderData.price,
                " z\u0142",
                React.createElement("br", null),
                "Metoda p\u0142atno\u015Bci:",
                " ",
                orderData.paymentMethod == "cash" ?
                    "Przy odbiorze"
                    : orderData.paymentMethod == "electronic" ?
                        "Elektronicznie"
                        : "Nie wybrano",
                React.createElement("br", null),
                React.createElement("span", { className: "loading-component-container" },
                    React.createElement("div", null,
                        "Stan P\u0142atno\u015Bci:",
                        " ",
                        orderData.paymentState == "while_ordering" ?
                            "W trakcie zamawiania"
                            : orderData.paymentState == "waiting_for_payment" ?
                                "Oczekuje na płatność"
                                : (orderData.paymentState == "payed" &&
                                    orderData.paymentMethod == "cash") ?
                                    "Przy odbiorze"
                                    : "Opłacone"),
                    React.createElement("br", null),
                    orderData.paymentState === "waiting_for_payment" && (React.createElement(LoadingComponent, { color: "classic" })),
                    orderData.paymentState === "payed" &&
                        orderData.isConnectedWithCollection && (React.createElement(LinkToCollection, { orderId: orderId, orderKey: key }))),
                React.createElement(OrderedImagesList, { order: {
                        orders: orderData.items.map((item) => ({
                            ...item,
                            offerName: item.label,
                            orderedFormats: item.orderedFormats,
                        })),
                        oneTimeOrders: orderData.oneTimeItems,
                    } }),
                orderData.paymentState == "waiting_for_payment" &&
                    orderData.paymentMethod == "electronic" &&
                    orderData.canShowPayButton &&
                    !orderData.isGroupBlocked && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { text: "Op\u0142a\u0107 ponownie", version: "classic", value: "pay_again", onClick: async () => {
                            const _ = { ...orderData };
                            setOrderData(undefined);
                            const { url } = await executeRequest(`/api/public/users/order/${orderId}/pay?key=${key}`, "GET", {});
                            if (url) {
                                window.open(url, "_self");
                                return;
                            }
                            setOrderData(_);
                            toast.error("Nie udało się przekierowac do płatności");
                        } }))))));
}
